<template>
  <div>
    <!-- 面包屑导航区 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>申请管理</el-breadcrumb-item>
      <el-breadcrumb-item>身份证绑定申请</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片视图 -->


    <el-card >
      <el-alert
        title="用于身份证Excel模式上传,具体使用方式咨询客服"
        type="warning"
        center
        show-icon>
      </el-alert>

    </el-card>


    <el-card>
      <!-- 搜索 添加 -->
      <el-row :gutter="20">
        <el-col :span="4">

          <el-select v-model="queryInfo.examineStatus" placeholder="请选择">
            <el-option
              v-for="item in examineStatusList"
              :key="item.type"
              :label="item.name"
              :value="item.type">
            </el-option>
          </el-select>

        </el-col>

        <el-col :span="4">
          <el-input placeholder="请输入姓名" v-model="queryInfo.userName" clearable @clear="getUserList">     <!-- clearable可清空搜索数据之后返回整体的菜单 -->

          </el-input>
        </el-col>
        <el-col :span="6">
          <el-input placeholder="请输入手机号" v-model="queryInfo.phone" clearable @clear="getUserList">     <!-- clearable可清空搜索数据之后返回整体的菜单 -->

            <el-button slot="append" icon="el-icon-search" @click="getUserList">查询</el-button>

          </el-input>
        </el-col>


        <el-col :span="2.2">
          <el-button type="primary" @click="bathApproval()">审批批量通过</el-button>
        </el-col>
        <el-col :span="2.2">
          <el-button type="success" @click="exportExcel">导出名单</el-button>
        </el-col>
      </el-row>
      <!-- 用户列表区域 -->
      <el-table :data="userlist"  @selection-change="handleSelectionChange" border stripe>
        <el-table-column
          type="selection"
          width="40">
        </el-table-column>
        <el-table-column type="index" width="70" label="序号"></el-table-column>
        <el-table-column prop="userName" label="姓名"></el-table-column>
        <el-table-column prop="phone" label="手机号"></el-table-column>
        <el-table-column prop="examineStatus" label="状态"></el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column prop="examineTime" label="审批时间"></el-table-column>
<!--        <el-table-column  label="状态">-->
<!--          <template slot-scope="scope">-->
<!--            <el-switch-->
<!--              v-model="scope.row.mg_state" @change="userStateChanged(scope.row)">-->
<!--            </el-switch>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column  label="操作" width="185px">
           <template slot-scope="scope">
             <!-- 通过拒绝 -->
             <div>
               <el-button type="primary" icon="el-icon-edit" size="mini" @click="approval([scope.row.identityCardApplyId],1)">通过</el-button>
               <!-- 删除按钮 -->
               <el-button type="info" icon="el-icon-delete" size="mini" @click="deleteIdentityCardApply(scope.row.identityCardApplyId)">删除</el-button>
             </div>
             <div style="margin-top: 10px">
               <!-- 拒绝按钮 -->
               <el-button type="danger" icon="el-icon-delete" size="mini" @click="approval([scope.row.identityCardApplyId],2)">拒绝</el-button>

             </div>


           </template>
        </el-table-column>
      </el-table>
    <!-- 分页区域 -->
     <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.page"
          :page-sizes="[20]"
          :page-size="queryInfo.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
        <!-- 添加用户对话框 -->
    </el-card>
 </div>
</template>

<script>
export default {
  data () {
     // 自定义邮箱规则
        var checkEmail = (rule, value, callback) => {
          const regEmail = /^\w+@\w+(\.\w+)+$/
          if (regEmail.test(value)) {
            // 合法邮箱
            return callback()
          }
           // 返回一个错误提示
          callback(new Error('请输入合法邮箱'))
        }
        // 自定义手机号规则
        var checkMobile = (rule, value, callback) => {
          const regMobile = /^1[34578]\d{9}$/
          if (regMobile.test(value)) {
            return callback()
          }
          // 返回一个错误提示
          callback(new Error('请输入合法的手机号码'))
        }
    return {
      //获取用户列表的参数对象
      queryInfo: {
        phone: '',
        userName:'',
        //当前的页数
        page: 1,
        //当前每页显示多少条数据
        limit: 20,
        examineStatus:-1
      },
      userlist: [],
      total: 0,
      multipleSelection:[],
      examineStatusList:[
        {
          type:-1,
          name:'全部'
        },
        {
          type:0,
          name:'未审核'
        },
        {
          type:1,
          name:'审核通过'
        },
        {
          type:2,
          name:'审核拒绝'
        },
      ]
      }
  },
  created () {
    this.getUserList()
  },
  methods: {
    async getUserList() {
      const {data: res} = await this.$http.get('identityCardApply/selectIdentityCardApplyListV2', {
        params: this.queryInfo,
      })   //get参数用params获得
      if (res.code !== '10000') {
        return this.$message.error(res.msg)
      }
      this.userlist = res.data.list;
      this.total = res.data.count
    },
    // 监听pagesize 改变的事件
    handleSizeChange(newSize) {
      // console.log(newSize)
      this.queryInfo.limit = newSize
      this.getUserList()
    },
    // 监听页码值改变的事件
    handleCurrentChange(newPage) {
      // console.log(newPage)
      this.queryInfo.page = newPage
      this.getUserList()
    },
    //根据id删除对应信息
    bathApproval: async function () {
      const confirmResult = await this.$confirm(            //promise  用await
        '是否确认审批?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err)
      // 点击确定 返回值为：confirm
      // 点击取消 返回值为： cancel
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消')
      }

      let list = this.multipleSelection;
      let ids = [];
      list.forEach(function(value, key, arr) {
        ids.push(value.identityCardApplyId);
      });

      if(ids.length == 0){
        return this.$message.info('未选中审批内容');
      }
      var param = {};
      param.ids = ids;
      param.examineStatus = 1;

      const {data: res} = await this.$http.post('/identityCardApply/examineIdentityCardApplyV2',param)

      if (res.code !== '10000') return this.$message.error('审批失败！')
      this.$message.success('审批成功！')
      this.getUserList()
    },
    async exportExcel(){
      const {data: res} = await this.$http.get('/identityCardApply/export')
      if (res.code !== '10000') return this.$message.error(res.msg)

      window.location.href= res.data.url;
      this.$message.success('导出成功！')
    },
    async approval(id, type) {
      var param = {};
      param.ids = id;
      param.examineStatus = type;
      const {data: res} = await this.$http.post('/identityCardApply/examineIdentityCardApplyV2',param)

      if (res.code !== '10000') return this.$message.error('审批失败！')
      this.$message.success('审批成功！')
      this.getUserList()

    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    async deleteIdentityCardApply(id){

      var param = {};
      param.identityCardApplyId = id;

      const confirmResult = await this.$confirm(
        '此操作将删除该数据, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(error => error)
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消删除')
      } else {
        const {data: res} = await this.$http.post('/identityCardApply/delete',param)
        if (res.code !== '10000') return this.$message.error('删除失败！')
        this.$message.success('删除成功！')
        this.getUserList()
      }


    }

  }
}

</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/apply/IdentityCardApply.vue